import { connect } from 'react-redux';

import ChangeRequestComment from './ChangeRequestComment';

export default connect(({ discussion: { usersById } }) => ({
  usersById,
}))(ChangeRequestComment);
